export default {
  fields: {
    email: "Email",
    displayName: "Display name",
    password: "Password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    resetToken: "Reset code",
    togglePassword: "Show or hide value",
  },
  validation: {
    required: "Required field",
    email: "Enter a valid email address",
    passwordLength: "Use at least 12 characters",
    passwordMatch: "Passwords do not match",
  },
  errors: {
    rateLimited: "Too many attempts. Please try again later.",
    service: "The service is temporarily unavailable. Please try again.",
  },
  login: {
    title: "Sign in",
    action: "Sign in",
    noAccount: "No account yet?",
    invalid: "The email or password is incorrect.",
  },
  register: {
    title: "Create account",
    action: "Register",
    hasAccount: "Already have an account?",
    failed: "Registration could not be completed. Check the fields and try again.",
    accountExists: "An account with this email already exists",
  },
  forgot: {
    title: "Forgot password",
    link: "Forgot password?",
    description: "Enter your email. The same response is shown whether or not an account exists.",
    action: "Request reset",
    accepted: "If an account exists, reset instructions have been sent.",
    back: "Back to sign in",
  },
  reset: {
    title: "Reset password",
    description: "Paste the one-time reset code from your message. It is not stored in the URL.",
    action: "Set new password",
    invalid: "The reset code is invalid or expired.",
    done: "Your password has been changed. You can now sign in.",
  },
}
